
define([
	"dojo/_base/declare",
	"csi/locale",
	"csi/heading/StringType"
], function(declare,locale,StringType) {
	/**
	 * Replaces Current File Version with "Current" keyword
	 * @param declare
	 * @param locale
	 * @returns
	 */
	return declare(StringType, {
		_getValue: function(/*Context*/ctx, /*Heading*/h) {
			if(!ctx.getNode().Version){
				return locale.resource("DriveCurrentVersion");
			}
			return ctx.getNode().CDVersion;
		}
	});
});